export interface IRecordRangeInput {
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
}

export interface IRecordRange {
  startRecord: number;
  endRecord: number;
  canGoPrevious: boolean;
  canGoNext: boolean;
}

/** @registry Chunk-navigation math shared by every src/design/molecules pagination control: the 1-based record range shown for the current page and whether prev/next are reachable. */
export const getRecordRange = ({
  page,
  pageSize,
  totalCount,
  totalPages,
}: IRecordRangeInput): IRecordRange => ({
  startRecord: totalCount === 0 ? 0 : (page - 1) * pageSize + 1,
  endRecord: Math.min(page * pageSize, totalCount),
  canGoPrevious: page > 1,
  canGoNext: page < totalPages,
});
